// Decide what the session timer should do in response to a door scan.
//
// A face-entry *entry* scan starts a billable session (the timer/credits banner appears),
// but only if one isn't already running. Any *exit* ends the running session,
// which triggers the time-based charge (walk-in) or the early-leave refund
// (booked). Everything else (e.g. a fingerprint/code entry, or an exit with no
// session) is ignored — the existing manual "Leave Room" and 3-hour auto-close
// still cover those paths.

export interface DoorEvent {
  event_type?: string;
  auth_method?: string;
}

export type DoorSessionAction = "start" | "stop" | "ignore";

export function doorSessionAction(
  event: DoorEvent,
  isSessionActive: boolean,
): DoorSessionAction {
  if (event.event_type === "entry" && event.auth_method === "face") {
    return isSessionActive ? "ignore" : "start";
  }
  if (event.event_type === "exit") {
    return isSessionActive ? "stop" : "ignore";
  }
  return "ignore";
}
